import React from 'react';
import { Button, Text, View } from "../../Components/Themed"
import type { CompanyProps, PollCampaignProps, PublicPlayerProps } from '../../types';
import { Image } from 'react-native';
import { useColors } from '../../constants/useColors';

type PollCampaignCardProps = {
    poll_campaign:PollCampaignProps,
    company?:CompanyProps,
    admin?:PublicPlayerProps,
    onSelectPollCampaign:(pc:PollCampaignProps) => void
}

const PollCampaignCard = ({ poll_campaign, onSelectPollCampaign }:PollCampaignCardProps) => {
    const Colors = useColors();

    return (
        <Button float style={{ flex:1, padding:0 }} onPress={() => onSelectPollCampaign(poll_campaign)}>
            <View type='header' style={{ flexDirection:'row', alignItems:'center', padding:10, borderTopRightRadius:8, borderTopLeftRadius:8 }}>
                <Image
                    source={{ uri: poll_campaign.campaign_image?.url ?? 'https://res.cloudinary.com/hoabts6mc/image/upload/v1722453927/default_man_n96ofq.webp' }}
                    style={{ height:45, width:45, borderRadius:4}}
                    resizeMode='cover'
                />
                <View transparent style={{ flex:1, marginLeft:10, marginRight:10  }}>
                    <Text theme='h2'>{poll_campaign.name}</Text>
                    <Text style={{ marginTop:3 }} theme='description'>{poll_campaign.campaign_type.toUpperCase()}</Text>
                </View>
                
            </View>
            <View transparent style={{ padding:10 }}>
                <View type='row' transparent>                 
                    <View transparent style={{ flex:1, justifyContent:'center', alignItems:'center' }}>
                        <Text size={18} color={Colors.text.h1} weight='bold'>{poll_campaign.total_polls}</Text>
                        <Text style={{ marginTop:3 }} theme='description'>Questions</Text>
                    </View>
                </View>
            </View>
            {poll_campaign.prize_override ?
            <View type='footer' style={{ flexDirection:'row', alignItems:'center', padding:10, borderBottomRightRadius:8, borderBottomLeftRadius:8 }}>
                <Image
                    source={{ uri: poll_campaign.prize_image?.url ?? 'https://res.cloudinary.com/hoabts6mc/image/upload/v1693344377/cash_prize_zalhgb.webp' }}
                    style={{ height:40, width:40 }}
                />
                <View transparent style={{ flex:1, marginLeft:10 }}>
                    <Text theme='h2' color={Colors.text.gold}>{poll_campaign.prize_override}</Text>
                </View>
            </View>
            :<></>}
        </Button>
    )
}

export default PollCampaignCard